import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.dataset;

export const datasetSelectors = {
  datasets: createSelector(selector, (state) => state.datasets),
};
